/**
 * @generated SignedSource<<afa61578c0590c144cb3048e774457e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeRoleEditEmployeesDialog_EmployeeItem$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "EmployeeRoleEditEmployeesDialog_EmployeeItem";
};
export type EmployeeRoleEditEmployeesDialog_EmployeeItem$key = {
  readonly " $data"?: EmployeeRoleEditEmployeesDialog_EmployeeItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditEmployeesDialog_EmployeeItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeRoleEditEmployeesDialog_EmployeeItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "60d0c58dac539d86dd240152b52b0033";

export default node;
